// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_1T872","Title":"Hero__Title_1QAGM","Level":"Hero__Level_33-5S","LevelTitle":"Hero__LevelTitle_1ycIO","LevelLink":"Hero__LevelLink_35yx7"};